import { rem } from 'polished';
import styled from 'styled-components';

import { IStyledWrapperProps } from './TelephoneInput.types';

export const StyledLabel = styled.label`
  position: absolute;
  top: ${rem('30px')};
  left: 0;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${({ theme }) => rem(theme.spacings.s)};
  line-height: 1.4;
  pointer-events: none;
`;

export const StyledWrapper = styled.div<IStyledWrapperProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  padding-top: ${rem('29px')};
  padding-bottom: ${rem('20px')};
  flex: 1;
  ${({ inputValue }) =>
    !!inputValue &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}

  ${({ isActive }) =>
    isActive &&
    `
    ${StyledLabel} {
      top: 0;
    }
  `}
`;
